<template>
  <section>
    <div class="desktop-table is-hidden-mobile">
      <BTable
        :data="data"
        ref="table"
        detailed
        hoverable
        custom-detail-row
        :opened-detailed="expandedRows"
        :detail-key="detailKey"
        @details-open="onOpenDetails"
        @details-close="onCloseDetails"
        show-detail-icon
        bordered
        :mobile-cards="true"
      >
        <template slot-scope="props">
          <BTableColumn
            v-for="(column, index) in columns"
            :key="index"
            class="has-detail-rows"
            :field="column.name"
            :visible="column.display"
            :label="column.title"
            :sortable="column.sortable"
            :centered="index !== 0"
            :width="column.width || ''"
            :class="
              (`parent-row-${props.index}`,
              { 'hover-table': index > 1 && processedAverage(column.isAverageOfLeague, props.row[column.name]) > 0 })
            "
          >
            <template v-if="index > 1 && processedAverage(column.isAverageOfLeague, props.row[column.name]) > 0">
              <div
                class="number-pc-hover"
                @click="setOpenMedia(processedAverage(column.isAverageOfLeague, props.row[column.name]), column, props)"
              >
                {{ processedAverage(column.isAverageOfLeague, props.row[column.name]) }}
              </div>
            </template>
            <template v-else>
              {{ processedAverage(column.isAverageOfLeague, props.row[column.name]) }}
            </template>
          </BTableColumn>
        </template>

        <template slot="detail" slot-scope="props">
          <tr class="detailed-row" v-for="item in props.row.items" :key="item.category">
            <td />
            <td
              v-for="(column, index) in columns"
              :key="index"
              :class="{
                'has-text-centered': column.name !== detailKey,
                'hover-table': index > 1 && processedAverage(column.isAverageOfLeague, item[column.name]) > 0,
              }"
              v-show="column.display"
            >
              <template v-if="index > 1 && processedAverage(column.isAverageOfLeague, item[column.name]) > 0">
                <div
                  class="number-pc-hover"
                  @click="
                    setOpenMediaChild(processedAverage(column.isAverageOfLeague, item[column.name]), column, item)
                  "
                >
                  {{ processedAverage(column.isAverageOfLeague, item[column.name]) }}
                </div>
              </template>
              <template v-else> {{ processedAverage(column.isAverageOfLeague, item[column.name]) }}</template>
            </td>
          </tr>
        </template>
      </BTable>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
const rivalSubjectCategoryNames = ['Goles recibidos'];

export default {
  name: 'DataTable',
  props: {
    detailKey: {
      type: String,
      required: false,
      default: 'category',
    },
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    expandedRows: {
      type: Array,
      required: false,
      default: function() {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters({
      getGamesPlayedByTeam: 'filterGeneral/getGamesPlayedByTeam',
      stadisticId: 'filterGeneral/getStadisticId',
    }),
    ...mapGetters('filterGeneral', {
      getGamesPlayedByTeam: 'getGamesPlayedByTeam',
      getResults: 'getResults',
      getSections: 'getSections',
      getPlayingAs: 'getPlayingAs',
      getSelectedGamesIds: 'getSelectedGamesIds',
      seasonSelected: 'getSeasonId',
    }),
    ...mapGetters('teamsGeneral', {
      teamId: 'teamId',
    }),
    ...mapGetters('playersGeneral', {
      playerId: 'playerId',
    }),
    ...mapState('filterGeneral', {
      selectedCategory: 'categoryType',
      tournamentsForMediaPlayer: 'tournamentsForMediaPlayer',
    }),
    gamesPlayed() {
      return this.getGamesPlayedByTeam === 0 ? 1 : this.getGamesPlayedByTeam;
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.removeExpandArrows();
      },
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    getGeneralName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word, index) => {
          if (index === 0) {
            if (word.includes('.')) {
              accumulator.push(word);
            } else {
              const wordAux = word.toLowerCase().split('');
              wordAux[0] = wordAux[0].toUpperCase();
              accumulator.push(wordAux.join(''));
            }
          } else {
            accumulator.push(word.toLowerCase());
          }
          return accumulator;
        }, [])
        .join(' ');
    },
    getSingleName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word) => {
          let wordAux = word;
          if (word.endsWith('vocan')) {
            wordAux = word.replace('vocan', 'voca');
          } else if (word.endsWith('lones')) {
            wordAux = word.replace('lones', 'lón');
          } else if (word.endsWith('oles')) {
            wordAux = word.replace('oles', 'ol');
          } else if (word.endsWith('os') || word.endsWith('as') || word.endsWith('es')) {
            wordAux = word.slice(0, word.length - 1);
          }
          accumulator.push(wordAux);
          return accumulator;
        }, [])
        .join(' ');
    },
    setOpenMediaChild(value, column, props) {
      const generalName = this.getGeneralName(props.generalName || props.category);
      const singleName = this.getSingleName(generalName);
      if (value > 0) {
        var timeFilter = '';
        switch (column.name) {
          case 'period1':
            timeFilter = 1;
            break;
          case 'period2':
            timeFilter = 2;
            break;
          case 'period3':
            timeFilter = 3;
            break;
          case 'period4':
            timeFilter = 4;
            break;
          case 'period5':
            timeFilter = 5;
            break;
          case 'period6':
            timeFilter = 6;
            break;
        }
        let categoryIds = [];
        if (props.categoryIds) {
          categoryIds = categoryIds.concat(props.categoryIds)
        }
        if (props.rCategoryIds) {
          props.rCategoryIds.forEach(categoryId => {
            categoryIds.push(`${categoryId}_r`)
          });
        }
        const jsonConfig = {
          seasonId: this.seasonSelected,
          tournaments: this.tournamentsForMediaPlayer,
          categoryIds,
          categorySingleName: singleName,
          mainSectionType: 1,
          gameIds: this.getSelectedGamesIds,
          matchResult: this.getResults,
          playData: [],
          advancedFilter: {
            playListTitle: generalName,
            mainCategoryId: {},
            playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
            timeSections: timeFilter === '' ? this.getSections : [timeFilter],
            fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
          },
        };
        if (this.teamId) {
          jsonConfig.playerIds = [];
          jsonConfig.teamId = this.teamId;
          jsonConfig.playListType = 3;
        } else {
          jsonConfig.playerIds = [this.playerId];
          jsonConfig.teamId = 0;
          jsonConfig.playListType = 2;
        }
        this.setModalInitialState(jsonConfig);
        this.setIsModalOpen(true);
      }
    },
    setOpenMedia(value, column, props) {
      const generalName = this.getGeneralName(props.row.category);
      const singleName = this.getSingleName(generalName);
      if (value > 0) {
        let allCategories = [];
        if (!props.categoryIds && props.row.items) {
          for (const subcategory of props.row.items) {
            if (subcategory.categoryIds) {
              allCategories = allCategories.concat(subcategory.categoryIds);
            }
            if (subcategory.rCategoryIds) {
              subcategory.rCategoryIds.forEach(categoryId => {
                allCategories.push(`${categoryId}_r`);
              });
            }
          }
        } else {
          if (props.row.categoryIds) {
            allCategories = allCategories.concat(props.row.categoryIds);
          }
          if (props.row.rCategoryIds) {
            props.row.rCategoryIds.forEach(categoryId => {
              allCategories.push(`${categoryId}_r`);
            });
          }
        }
        let timeFilter = '';
        switch (column.name) {
          case 'period1':
            timeFilter = 1;
            break;
          case 'period2':
            timeFilter = 2;
            break;
          case 'period3':
            timeFilter = 3;
            break;
          case 'period4':
            timeFilter = 4;
            break;
          case 'period5':
            timeFilter = 5;
            break;
          case 'period6':
            timeFilter = 6;
            break;
        }
        const isRivalSubject = this.teamId && generalName.includes('recibido')
        let jsonConfig = {
          seasonId: this.seasonSelected,
          tournaments: this.tournamentsForMediaPlayer,
          categoryIds: props.categoryIds == null ? allCategories : props.categoryIds,
          categorySingleName: singleName,
          mainSectionType: 1,
          gameId: this.getSelectedGamesIds,
          matchResult: this.getResults,
          playData: [],
          isRivalSubject,
          avoidCategorySingleName: isRivalSubject,
          advancedFilter: {
            playListTitle: generalName,
            mainCategoryId: {},
            playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
            timeSections: timeFilter == '' ? this.getSections : [timeFilter],
            fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
          },
        };
        if (this.teamId) {
          jsonConfig.playerIds = [];
          jsonConfig.teamId = this.teamId;
          jsonConfig.playListType = 3;
        } else {
          jsonConfig.playerIds = [this.playerId];
          jsonConfig.teamId = 0;
          jsonConfig.playListType = 2;
        }
        this.setModalInitialState(jsonConfig);
        this.setIsModalOpen(true);
      }
    },
    processedAverage(isAverageOfLeague, value) {
      //when statistic is '1' there's no need to divide because gamesPlayed is 1 and there's no decimals
      const VAL = typeof value === 'string' || this.stadisticId === 1 ? value : (value / this.gamesPlayed).toFixed(2);
      return isAverageOfLeague ? value.toFixed(2) : VAL;
    },
    toggle(row) {
      debugger;
      this.$refs.table.toggleDetails(row);
    },
    onOpenDetails(row) {
      this.$emit('showDetails', row.category);
    },
    onCloseDetails(row) {
      this.$emit('hideDetails', row.category);
    },
    removeExpandArrows() {
      this.data.forEach((tableRow, index) => {
        if (!tableRow.items) {
          const childCells = document.querySelector(`.parent-row-${index}`);
          if (childCells) {
            const arrowCell = childCells.parentNode.firstChild;
            if (arrowCell.firstChild) {
              arrowCell.removeChild(arrowCell.firstChild);
            }
          }
        }
      });
    },
  },
  mounted() {
    this.removeExpandArrows();
  },
};
</script>
<style>
.hover-table:hover {
  background: #cbee6b !important;
  opacity: 0.8 !important;
  cursor: pointer !important;
  color: #00a5ff !important;
}
.number-pc-hover {
  text-decoration: underline !important;
}
</style>
